import axios from "axios";
import { OrganizationURL } from "../../../config/UrlEndPoint";

export const URL = `${OrganizationURL}organization/`;

//Get By ID
export function getOrganizationFileById(organizationFileId) {
  return axios.get(`${URL}/${organizationFileId}`);
}

// items => filtered/sorted result for table data
export function findOrganizationFile(queryParams) {
  return axios.post(`${URL}find_organization_file`, queryParams);
}

// POST => POST: Create the organizationFile on the server
export function createOrganizationFile(organizationFile) {
  return axios.post(`${URL}upload_file`, organizationFile);
}

// DELETE => DELETE: Organization File
export function deleteOrganizationFile(organizationFile) {
  return axios.delete(`${URL}delete_file`, { data: organizationFile });
}

// UPDATE => UPDATE: Organization File
export function updateOrganizationFile(payload) {
  return axios.put(`${URL}update_org_file`, payload);
}

export const getOrganization = () => {
  return axios.get(`${URL}`);
};

export const updateOrgOwnerUser = payload => {
  return axios.put(`${URL}update_org_owner_user`, payload);
};

export function updateDocumentConfirmation() {
  return axios.patch(`${URL}submit-confirm`);
}
